const configNode = document.getElementById('VeluneSparseComponentConfig');

let urls = {};
try {
  urls = JSON.parse(configNode?.textContent || '{}');
} catch (_) {
  urls = {};
}

const components = [
  {
    key: 'productSku',
    tag: 'product-sku-component',
    selector: 'product-sku-component',
    url: urls.productSku,
  },
  {
    key: 'productInventory',
    tag: 'product-inventory',
    selector: 'product-inventory',
    url: urls.productInventory,
  },
  {
    key: 'volumePricing',
    tag: 'volume-pricing',
    selector: 'volume-pricing',
    url: urls.volumePricing,
  },
  {
    key: 'pricePerItem',
    tag: 'price-per-item',
    selector: 'price-per-item',
    url: urls.pricePerItem,
  },
  {
    key: 'volumePricingInfo',
    tag: 'volume-pricing-info',
    selector: 'volume-pricing-info',
    url: urls.volumePricingInfo,
  },
  {
    key: 'media',
    tag: 'deferred-media',
    selector: 'deferred-media, product-model',
    url: urls.media,
  },
  {
    key: 'videoBackground',
    tag: 'video-background-component',
    selector: 'video-background-component',
    url: urls.videoBackground,
  },
  {
    key: 'rteFormatter',
    tag: 'rte-formatter',
    selector: 'rte-formatter',
    url: urls.rteFormatter,
  },
  {
    key: 'accordionCustom',
    tag: 'accordion-custom',
    selector: 'accordion-custom',
    url: urls.accordionCustom,
  },
  {
    key: 'anchoredPopover',
    tag: 'anchored-popover-component',
    selector: 'anchored-popover-component',
    url: urls.anchoredPopover,
  },
  {
    key: 'floatingPanel',
    tag: 'floating-panel-component',
    selector: 'floating-panel-component',
    url: urls.floatingPanel,
  },
  {
    key: 'showMore',
    tag: 'show-more-component',
    selector: 'show-more-component',
    url: urls.showMore,
  },
  {
    key: 'productTitle',
    tag: 'product-title',
    selector: 'product-title',
    url: urls.productTitle,
  },
];

const imports = new Map();
let quickAddObserver = null;
let observedQuickAddRoot = null;

function rootContains(root, selector) {
  if (!root) return false;
  if (root instanceof Element && root.matches(selector)) return true;
  return Boolean(root.querySelector?.(selector));
}

function loadComponent(component) {
  if (!component.url || customElements.get(component.tag) || imports.has(component.key)) return;

  const request = import(component.url).catch((error) => {
    imports.delete(component.key);
    console.error(`[Velune] Failed to load ${component.key}`, error);
  });

  imports.set(component.key, request);
}

function scan(root = document) {
  for (const component of components) {
    if (rootContains(root, component.selector)) loadComponent(component);
  }
}

function scanAddedNodes(nodes) {
  for (const node of nodes) {
    if (node instanceof Element) scan(node);
  }
}

function ensureQuickAddObserver() {
  const root = document.getElementById('quick-add-modal-content');
  if (!root || root === observedQuickAddRoot) return;

  quickAddObserver?.disconnect();
  observedQuickAddRoot = root;
  quickAddObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) scanAddedNodes(mutation.addedNodes);
  });
  quickAddObserver.observe(root, { childList: true, subtree: true });
  scan(root);
}

function init() {
  scan(document);
  ensureQuickAddObserver();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => {
  scan(event.target instanceof Element ? event.target : document);
  ensureQuickAddObserver();
});

document.addEventListener('shopify:block:select', (event) => {
  scan(event.target instanceof Element ? event.target : document);
});

for (const eventName of ['variant:update', 'cart:update']) {
  document.addEventListener(eventName, () => {
    queueMicrotask(() => scan(document));
  });
}
